import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@mui/material';
import { StyledTableBodyCell, StyledTableRow } from 'components/common/Styles';
import { set, get, useChangeTrackingLens } from '@totalsoft/change-tracking-react';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';
import { emptyString } from 'utils/constants';

const ContentTypeXUserGroupComponent = ({ index, contentTypeXUserGroup, userGroups, canWrite, onChange, saving }) => {
  const [lens, , resetLens] = useChangeTrackingLens(contentTypeXUserGroup);

  useEffect(() => {
    resetLens(contentTypeXUserGroup);
  }, [contentTypeXUserGroup, resetLens]);

  const handleChange = property => value => {
    onChange(contentTypeXUserGroup.userGroupId, property, value);
    (lens[property] |> set)(value);
  };

  const userGroupName = useMemo(() => {
    const userGroup = userGroups.userGroupsList && userGroups.userGroupsList.find(group => group.id === contentTypeXUserGroup?.userGroupId);
    return userGroup.name;
  }, [contentTypeXUserGroup, userGroups]);

  return (
    <StyledTableRow hover key={index}>
      <StyledTableBodyCell colSpan={1}>{userGroupName || emptyString}</StyledTableBodyCell>
      <StyledTableBodyCell colSpan={1}>
        <Checkbox
          disabled={!canWrite || saving}
          checked={(lens.canRead |> get) || false}
          onChange={handleChange('canRead') |> onCheckBoxChange}
        />
      </StyledTableBodyCell>
      <StyledTableBodyCell colSpan={1}>
        <Checkbox
          disabled={!canWrite || saving}
          checked={(lens.canWrite |> get) || false}
          onChange={handleChange('canWrite') |> onCheckBoxChange}
        />
      </StyledTableBodyCell>
      <StyledTableBodyCell colSpan={1}>
        <Checkbox
          disabled={!canWrite || saving}
          checked={(lens.canDelete |> get) || false}
          onChange={handleChange('canDelete') |> onCheckBoxChange}
        />
      </StyledTableBodyCell>
      <StyledTableBodyCell colSpan={1}>
        <Checkbox
          disabled={!canWrite || saving}
          checked={(lens.canVerify |> get) || false}
          onChange={handleChange('canVerify') |> onCheckBoxChange}
        />
      </StyledTableBodyCell>
    </StyledTableRow>
  );
};

ContentTypeXUserGroupComponent.propTypes = {
  index: PropTypes.number,
  contentTypeXUserGroup: PropTypes.object,
  userGroups: PropTypes.object,
  canWrite: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  saving: PropTypes.bool
};

export default ContentTypeXUserGroupComponent;
